var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlipay = function SvgAlipay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "-105 -105 240 240",
    xmlSpace: "preserve"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#00a1e9",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "matrix(2.72 0 0 2.72 -77.047 -82.383)",
    d: "M10.873 1.867C4.863 1.867 0 6.734 0 12.743V58.87c0 6.005 4.863 10.874 10.873 10.874h46.134c6.006 0 10.872-4.87 10.872-10.874v-.47c-.203-.084-17.642-7.358-26.505-11.62-5.98 7.36-13.693 11.824-21.701 11.824-13.542 0-18.14-11.852-11.729-19.654 1.398-1.7 3.777-3.325 7.468-4.235 5.774-1.418 14.964.886 23.577 3.728a47.18 47.18 0 0 0 3.823-9.344H16.27V26.41h13.686v-4.82H13.379V18.9h16.577v-6.876s0-1.159 1.174-1.159h6.69V18.9h16.388v2.69H37.82v4.82h13.377c-1.28 5.244-3.224 10.071-5.663 14.308 4.06 1.469 7.703 2.862 10.42 3.771 9.058 3.032 11.597 3.402 11.925 3.44V12.744c0-6.009-4.865-10.876-10.871-10.876H10.874zm7.444 36.777c-.581.007-1.165.038-1.753.096-1.696.17-4.88.919-6.62 2.459-5.217 4.55-2.095 12.867 8.464 12.867 6.138 0 12.271-3.924 17.09-10.208-6.212-3.03-11.562-5.28-17.18-5.214z"
  }));
};
export default SvgAlipay;